import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { URLBuilder2mz8zkz4u9ray as URLBuilder } from '../../../../../ktor-ktor-http/io/ktor/http/URLBuilder.mjs';
import { Companion_getInstance13wwf84j92s7c as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMethod.mjs';
import { HeadersBuilder3h7sn3kkvu98m as HeadersBuilder } from '../../../../../ktor-ktor-http/io/ktor/http/Headers.mjs';
import { EmptyContent_getInstance3cnuw24sjv05w as EmptyContent_getInstance } from '../utils/Content.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { get_BodyTypeAttributeKey1jqpsdtzeru4e as get_BodyTypeAttributeKey } from './RequestBody.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { OutgoingContent3t2ohmyam9o76 as OutgoingContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { takeFromkqlcz7c6dx2r as takeFrom } from '../../../../../ktor-ktor-http/io/ktor/http/URLUtils.mjs';
import { appendAlltwnjnu28pmtx as appendAll } from '../../../../../ktor-ktor-utils/io/ktor/util/StringValues.mjs';
import {
  putAll10o0q8e6mgnzr as putAll,
  AttributeKey3aq8ytwgx54f7 as AttributeKey,
} from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { get_ENGINE_CAPABILITIES_KEYr1fjz8liznxo as get_ENGINE_CAPABILITIES_KEY } from '../engine/HttpClientEngineCapability.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { GMTDate36bhedawynxlf as GMTDate } from '../../../../../ktor-ktor-utils/io/ktor/util/date/DateJs.mjs';
import { ClientUpgradeContent299vg0lx1tyfp as ClientUpgradeContent } from './ClientUpgradeContent.mjs';
import { takeFrom3rd40szpqy350 as takeFrom_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLParser.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ResponseAdapterAttributeKey() {
  _init_properties_HttpRequest_kt__813lx1();
  return ResponseAdapterAttributeKey;
}
var ResponseAdapterAttributeKey;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
function HttpRequestBuilder$setCapability$lambda() {
  // Inline function 'kotlin.collections.mutableMapOf' call
  return LinkedHashMap().ec();
}
var HttpRequestBuilderClass;
function HttpRequestBuilder() {
  if (HttpRequestBuilderClass === VOID) {
    class $ {
      constructor() {
        this.k5n_1 = new (URLBuilder())();
        this.l5n_1 = Companion_getInstance().w55_1;
        this.m5n_1 = new (HeadersBuilder())();
        this.n5n_1 = EmptyContent_getInstance();
        this.o5n_1 = SupervisorJob();
        this.p5n_1 = AttributesJsFn(true);
      }
      v55() {
        return this.m5n_1;
      }
      g5r(value) {
        if (!(value == null)) {
          this.p5n_1.l4r(get_BodyTypeAttributeKey(), value);
        } else {
          this.p5n_1.n4r(get_BodyTypeAttributeKey());
        }
      }
      x60() {
        return this.p5n_1.j4r(get_BodyTypeAttributeKey());
      }
      l62(block) {
        return block(this.k5n_1, this.k5n_1);
      }
      l38() {
        var tmp = this.k5n_1.l38();
        var tmp_0 = this.l5n_1;
        var tmp_1 = this.m5n_1.l38();
        var tmp_2 = this.n5n_1;
        var tmp0_elvis_lhs = tmp_2 instanceof OutgoingContent() ? tmp_2 : null;
        var tmp_3;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No request transformation found: ' + toString(this.n5n_1);
          throw IllegalStateException().o(toString(message));
        } else {
          tmp_3 = tmp0_elvis_lhs;
        }
        return new (HttpRequestData())(tmp, tmp_0, tmp_1, tmp_3, this.o5n_1, this.p5n_1);
      }
      f5r(builder) {
        this.o5n_1 = builder.o5n_1;
        return this.u5x(builder);
      }
      u5x(builder) {
        this.l5n_1 = builder.l5n_1;
        this.n5n_1 = builder.n5n_1;
        this.g5r(builder.x60());
        takeFrom(this.k5n_1, builder.k5n_1);
        this.k5n_1.g59_1 = this.k5n_1.g59_1;
        appendAll(this.m5n_1, builder.m5n_1);
        putAll(this.p5n_1, builder.p5n_1);
        return this;
      }
      x5z(key, capability) {
        var tmp = get_ENGINE_CAPABILITIES_KEY();
        var capabilities = this.p5n_1.o4r(tmp, HttpRequestBuilder$setCapability$lambda);
        // Inline function 'kotlin.collections.set' call
        capabilities.x4(key, capability);
      }
      h5z(key) {
        var tmp0_safe_receiver = this.p5n_1.j4r(get_ENGINE_CAPABILITIES_KEY());
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u4(key);
      }
    }
    initMetadataForClass($, 'HttpRequestBuilder', HttpRequestBuilder);
    HttpRequestBuilderClass = $;
  }
  return HttpRequestBuilderClass;
}
function get_coroutineContext() {
  return this.i5o().gw();
}
var HttpRequestClass;
function HttpRequest() {
  if (HttpRequestClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'HttpRequest', VOID, VOID, [CoroutineScope()]);
    HttpRequestClass = $;
  }
  return HttpRequestClass;
}
var HttpRequestDataClass;
function HttpRequestData() {
  if (HttpRequestDataClass === VOID) {
    class $ {
      constructor(url, method, headers, body, executionContext, attributes) {
        this.v5q_1 = url;
        this.w5q_1 = method;
        this.x5q_1 = headers;
        this.y5q_1 = body;
        this.z5q_1 = executionContext;
        this.a5r_1 = attributes;
        var tmp = this;
        var tmp0_safe_receiver = this.a5r_1.j4r(get_ENGINE_CAPABILITIES_KEY());
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v4();
        tmp.b5r_1 = tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
      }
      toString() {
        return 'HttpRequestData(url=' + this.v5q_1.toString() + ', method=' + this.w5q_1.toString() + ')';
      }
    }
    initMetadataForClass($, 'HttpRequestData');
    HttpRequestDataClass = $;
  }
  return HttpRequestDataClass;
}
var HttpResponseDataClass;
function HttpResponseData() {
  if (HttpResponseDataClass === VOID) {
    class $ {
      constructor(statusCode, requestTime, headers, version, body, callContext) {
        this.x5o_1 = statusCode;
        this.y5o_1 = requestTime;
        this.z5o_1 = headers;
        this.a5p_1 = version;
        this.b5p_1 = body;
        this.c5p_1 = callContext;
        this.d5p_1 = GMTDate();
      }
      toString() {
        return 'HttpResponseData=(statusCode=' + this.x5o_1.toString() + ')';
      }
    }
    initMetadataForClass($, 'HttpResponseData');
    HttpResponseDataClass = $;
  }
  return HttpResponseDataClass;
}
var ResponseAdapterClass;
function ResponseAdapter() {
  if (ResponseAdapterClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ResponseAdapter');
    ResponseAdapterClass = $;
  }
  return ResponseAdapterClass;
}
function isUpgradeRequest(_this__u8e3s4) {
  _init_properties_HttpRequest_kt__813lx1();
  var tmp = _this__u8e3s4.y5q_1;
  return tmp instanceof ClientUpgradeContent();
}
function headers(_this__u8e3s4, block) {
  _init_properties_HttpRequest_kt__813lx1();
  // Inline function 'kotlin.apply' call
  var this_0 = _this__u8e3s4.v55();
  block(this_0);
  return this_0;
}
function url(_this__u8e3s4, urlString) {
  _init_properties_HttpRequest_kt__813lx1();
  takeFrom_0(_this__u8e3s4.k5n_1, urlString);
}
var properties_initialized_HttpRequest_kt_zh09pz;
function _init_properties_HttpRequest_kt__813lx1() {
  if (!properties_initialized_HttpRequest_kt_zh09pz) {
    properties_initialized_HttpRequest_kt_zh09pz = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ResponseAdapterAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(ResponseAdapter());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(ResponseAdapter()), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp$ret$2);
    ResponseAdapterAttributeKey = new (AttributeKey())(name, tmp$ret$1);
  }
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  get_coroutineContext as get_coroutineContext1djaai1ellg0c,
  HttpRequestBuilder as HttpRequestBuilder15f2nnx9sjuv1,
  HttpRequest as HttpRequest3fsc4149kgwfg,
  HttpResponseData as HttpResponseData2dozo5khuplr6,
  get_ResponseAdapterAttributeKey as get_ResponseAdapterAttributeKey1ll13ywinsgvd,
  headers as headers24pki7ce1busg,
  isUpgradeRequest as isUpgradeRequest3msdo2i9hxs68,
  url as url2l6iw5ri21nxb,
};
//endregion

//# sourceMappingURL=HttpRequest.mjs.map
